import DynamicDropdown, { OptionObject } from "@insite/mobius/DynamicDropdown";
import { CustomState } from "@preferredMedical/Store/CustomState";
import { CustomActions } from "@preferredMedical/Store/Reducers";
import React, { Component } from 'react';
import { connect, DispatchProp, ResolveThunks } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

interface OwnProps {
    blindShipmentText: string;
}

interface State {
    isBlindShipment: string,
    blindShipmentOptions: Array<OptionObject>;
}

const mapStateToProps = (state: CustomState) => {
    return {
        checkoutReviewAndSubmitState: state.custom.checkoutReviewAndSubmit,
    };
}

const mapDispatchToProps = (dispatch: ThunkDispatch<CustomState, any, CustomActions>) => {
    return {
        setIsBlindShipment: (isBlindShipment: string) => dispatch({ type: "Custom/Pages/CheckoutReviewAndSubmit/SetIsBlindShipment", isBlindShipment }),
    }
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>& ReturnType<typeof mapDispatchToProps>;

class CheckoutReviewAndSubmitBlindShipment extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isBlindShipment: "False",
            blindShipmentOptions: [
                {
                    optionText: "No",
                    optionValue: "False",
                    searchString: "No",
                },
                {
                    optionText: "Yes",
                    optionValue: "True",
                    searchString: "Yes",
                },
            ]
        }
        this.props.setIsBlindShipment("False");
    }

    render() {
        return (
            <div>
                <DynamicDropdown
                        label={this.props.blindShipmentText}
                        options={this.state.blindShipmentOptions}
                        onSelectionChange={async value => {
                                if (value) {
                                    await this.setState({ isBlindShipment: value });
                                    this.props.setIsBlindShipment(value);
                                }
                        }}
                        selected={this.state.blindShipmentOptions[0].optionValue}
                        required={true}
                        selectOnly={true}
                />
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutReviewAndSubmitBlindShipment);